"use strict";

import {loaderFactory} from "Subschema";
import card from "./cardValidator";
import Card from "./Card.jsx";
import cvc from "./cvcValidator";
import CVC from "./CVC.jsx";
import CardExpiryDate from "./CardExpiryDate.jsx";
import CardStyle from "./Card.less";

const loader = loaderFactory();

loader.addValidator({card, cvc});
loader.addType({Card, CardExpiryDate, CVC});
loader.addStyle('Card', CardStyle);

export default loader;


/** WEBPACK FOOTER **
 ** ./src/types/card/index.js
 **/